import { render, staticRenderFns } from "./question-carousel-item.vue?vue&type=template&id=109bdf72&scoped=true&"
import script from "./question-carousel-item.vue?vue&type=script&lang=js&"
export * from "./question-carousel-item.vue?vue&type=script&lang=js&"
import style0 from "./question-carousel-item.vue?vue&type=style&index=0&id=109bdf72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109bdf72",
  null
  
)

export default component.exports